import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from './../../../common/button/button.module';
import { DividerModule } from './../../../common/divider/divider.module';
import { IconModule } from './../../../common/icon/icon.module';
import { PipesModule } from './../../../common/pipes/pipes.module';
import { SpinnerModule } from './../../../common/spinner/spinner.module';
import { AttachmentPlaceloaderComponent } from './attachment-placeloader.component';

@NgModule({
  declarations: [AttachmentPlaceloaderComponent],
  exports: [AttachmentPlaceloaderComponent],
  imports: [IconModule, CommonModule, DividerModule, ButtonModule, SpinnerModule, PipesModule],
})
export class AttachmentPlaceloaderModule {}

export { AttachmentPlaceloaderComponent };
export { AttachmentPlaceloader } from './attachment-placeloader.types';
